module.exports = __webpack_public_path__ + "img/media-folder-plus.8360143f.svg";